var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "statusContainer" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isOnline || _vm.statusSyncing || _vm.productModel.id,
            expression: "!isOnline || statusSyncing || productModel.id",
          },
        ],
        staticClass: "statusIcon",
        on: { click: _vm.clickSave },
      },
      [
        _c(
          "i",
          {
            class: [
              "material-icons",
              {
                "animation-spin": _vm.statusSyncing,
              },
            ],
          },
          [_vm._v("\n\t\t\t" + _vm._s(_vm.mainIcon) + "\n\t\t")]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("\n\t\t\t" + _vm._s(_vm.text) + "\n\t\t")]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }